import React, { ReactNode } from 'react';

import Skeleton from '../Skeleton/Skeleton';

import { GetAllStatuses } from '@/graphql/contracts/_generated_/getAllStatuses.query';
import HeaderContractStatus from './components/HeaderContractStatus';
import {
  OneEvoMigrationData,
  PausedBiilingData
} from '@/pages/ContractDetails/ContractTitle/ContractTitle.container';
import styles from './page-header.module.scss';

interface IPageHeaderProps {
  isLoading?: boolean;
  icon?: ReactNode;
  title: string;
  subtitle?: string;
  status?: GetAllStatuses['contractStatuses'][number];
  billingType?: string[];
  pausedBillingData?: PausedBiilingData;
  oneEvoMigration?: OneEvoMigrationData;
}

export default function PageHeader(props: IPageHeaderProps) {
  const { title, icon, subtitle, isLoading, status, pausedBillingData, billingType, oneEvoMigration } = props;

  if (isLoading) {
    return <Skeleton width="300px" />;
  }

  return (
    <div className={styles['page-header']}>
      {icon && (
        <span className={styles.icon}>{icon}</span>
      )}

      <span className={styles.title}>{title}</span>

      {subtitle && (
        <div className={styles.subtitle}>{subtitle}</div>
      )}
      {status && (
        <div className={styles['secondary-component']}>
          <HeaderContractStatus
            status={status}
            pausedBillingData={pausedBillingData}
            billingType={billingType}
            oneEvoMigration={oneEvoMigration}
          />
        </div>
      )}
    </div>
  );
}
